import { render, staticRenderFns } from "./ChatBoxImageCarousel.vue?vue&type=template&id=0199c674&scoped=true&"
import script from "./ChatBoxImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ChatBoxImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxImageCarousel.vue?vue&type=style&index=0&id=0199c674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0199c674",
  null
  
)

export default component.exports